module.exports = __webpack_public_path__ + "media/images/invoice-template-light-688955a26d4bcadf0a2c51b07409d122.png";